import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { BlogListRequestBody, BlogListResponse } from "./types";

export class BlogListAPI extends BaseAPI<
    BlogListRequestBody,
    BlogListResponse
> {
    protected route = ApiRoutes.blog.list;
    protected method = RequestMethod.GET;
    protected params = ["page", "page_size"];
}
